<template>
  <div class="">
    <van-tabs v-model="activeTab" @click="onClickTab" color="#3083f4">
      <van-tab title="待审核" name="0"></van-tab>
      <van-tab title="已通过" name="1"></van-tab>
      <van-tab title="已驳回" name="2"></van-tab>
    </van-tabs>
    <!-- 搜索框 -->
    <div>
      <van-search show-action v-model="applyTime" placeholder="请选择申请时间" readonly @click="applyTimeShow = true">
        <template #action>
          <div @click="onapplyTimeSearch">清空</div>
        </template>
      </van-search>
    </div>
    <van-calendar
      v-model="applyTimeShow"
      @confirm="applyTimeClick"
      color="#3083f4"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      offset="20"
      :immediate-check="false"
      @load="onLoad"
      finished-text="没有更多了 ~"
      v-if="list.length > 0"
    >
      <div
        style="width: 100%; border-bottom: 1px solid #eaeaeb"
        v-for="(item, index) in list"
        :key="index"
        @click="handleSuccess2(item)"
      >
        <div class="box">
          <div class="top">
            <div style="flex: 1">
              <img src="../../assets/image/待处理.png" alt="" />
              <span class="title">{{ item.applyTime }}</span>
            </div>
            <span class="time">
              <span v-if="item.status == 0" style="color: #fbc21f">待审核</span>
              <span v-if="item.status == 1" style="color: #139659">通过</span>
              <span v-if="item.status == 2" style="color: #f04438">驳回</span>
            </span>
          </div>
          <div class="des" style="margin-top: 10px">
            <div class="time">补卡原因：{{ item.applyReason }}</div>
            <div class="time" v-if="item.examineUserName != null">审核人：{{ item.examineUserName }}</div>
            <div class="time" v-if="item.examineTime != null">审核时间：{{ item.examineTime }}</div>
            <div class="time" v-if="item.examineRemark != null">审核备注：{{ item.examineRemark }}</div>
          </div>
          <div class="result"></div>
        </div>
      </div>
    </van-list>
    <van-empty description="暂无申请记录" v-if="list.length == 0" />
  </div>
</template>

<script>
import { getRepairApplyPage } from '@/api/Industry'
export default {
  data() {
    return {
      activeTab: 0,
      hidden: true, //没有更多数据了
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      list: [],
      applyTime: null,
      pageNum: 1,
      applyTimeShow: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2030, 0, 31),
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 清空申请时间
    onapplyTimeSearch() {
      this.applyTime = null
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    // 选中申请时间
    applyTimeClick(date) {
      this.applyTimeShow = false
      this.applyTime = this.formatDate(date)
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    formatDate(val) {
      let date = new Date(val)
      return `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${
        date.getDate() < 10 ? '0' : ''
      }${date.getDate()}`
    },
    // tab切换
    onClickTab(e) {
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    // 下拉刷新
    onLoad() {
      this.loading = true
      this.pageNum = this.pageNum + 1
      this.getList()
    },
    getList() {
      getRepairApplyPage({
        applyUserId: this.$route.params.userId,
        pageNum: this.pageNum,
        pageSize: 10,
        status: this.activeTab,
        applyDate: this.applyTime,
      }).then((res) => {
        if (res.code == 200) {
          let rows = res.data.list
          this.list = this.list.concat(rows)
          this.loading = false
          if (!res.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log('结束')
            this.finished = true
          } else {
            this.finished = false
          }
        }
      })
    },
  },
}
</script>
<style scoped>
/deep/ .van-tab {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  border-bottom: 1px solid #eaeaeb;
}

/deep/ .van-tab--active {
  color: #1e1e1e;
  font-weight: bold;
}

/deep/ .van-tabs__line {
  width: 18px;
  height: 3px;
  background: #1e1e1e;
  border-radius: 2px;
  bottom: 20px;
}

/deep/ .van-search {
  padding: 10px 12px 7px;
}

/deep/ .van-search__content {
  background-color: #ededef;
  border-radius: 7px;
  width: 84%;
  flex: none;
}
/deep/ .van-search .van-cell .van-field__left-icon {
  color: #9a9a9a;
}

.box {
  margin: auto;
  width: 92%;
  margin-top: 14px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box img,
.Name {
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  vertical-align: middle;
  margin-right: 7px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 9px;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
}
.box .title {
  vertical-align: middle;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1e1e1e;
}
.time {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
}

.des .time {
  font-size: 13px;
  line-height: 20px;
}

.result {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #48d25f;
  margin: 6px 0 15px;
}
</style>
